export default "__VITE_ASSET__c588ac32__"